// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".upload-container[data-v-fb1fef3a]  {\n  text-align: center;\n}\n.upload-container[data-v-fb1fef3a] .el-upload-dragger .el-upload__text em {\n    color: inherit;\n}\n.upload-container[data-v-fb1fef3a] .el-upload__tip {\n    text-align: left;\n}\n.download-template[data-v-fb1fef3a] {\n  color: #409EFF;\n}\n", ""]);
// Exports
module.exports = exports;
